import React, {useState} from  'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretSquareDown, faCaretSquareUp, faCheck} from '@fortawesome/free-solid-svg-icons';

import "./Select.css";

const Select = ({values, handler}) => {

    const options = values||[''];

    const [actual, setActual] = useState(options[0]);
    const [isOpen, setIsOpen] = useState(false);

    let displayOp = (isOpen)? {display: 'inherit'}:{display: 'none'};
    let caret = (isOpen)? <FontAwesomeIcon className = 'caret' icon = {faCaretSquareUp}/> 
                            :<FontAwesomeIcon className = 'caret' icon = {faCaretSquareDown}/>; 

    const openSelector = () => {
        setIsOpen(!isOpen);
    };

    const handleSelected = (event) => {
        const value = event.target.getAttribute('value');

        setActual(value);
        handler(value);
        
        setIsOpen(false);
    };

    return(
        <div className = "select">
            <div className  = 'show row nowrap centerContent' onClick = {openSelector}>
                {actual} 
                {caret}
            </div>
            <div className = 'options column norawp' style = {displayOp}>
                {
                    options.map((option, i) => {
                        return <div key = {i} className = 'option' value = {option} onClick = {handleSelected}>
                            {option}
                            {(option === actual)? <FontAwesomeIcon className = 'check colorEIC3' value = {option} icon = {faCheck}/>:""}
                        </div>
                    })
                }
            </div>
        </div>
    );
};

export default Select;